var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReqDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.146,
    height: 14.274,
    viewBox: "0 0 16.146 14.274",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fe9532;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17860.486 -9959)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17860.486 9959)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 0.85,
    cy: 0.85,
    r: 0.85,
    transform: "translate(7.224 9.975)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.245,32.678a.953.953,0,0,0-.867,1.037L44.7,37.2a.651.651,0,0,0,.578.578.634.634,0,0,0,.7-.578l.323-3.484v-.17A.979.979,0,0,0,45.245,32.678Z",
    transform: "translate(-37.256 -28.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.292,18.706l-5.71-9.55a2.347,2.347,0,0,0-4.044,0l-5.71,9.55A2.35,2.35,0,0,0,4.85,22.274h11.4a2.329,2.329,0,0,0,2.056-1.19A2.3,2.3,0,0,0,18.292,18.706Zm-1.173,1.7a.965.965,0,0,1-.85.493H4.85A.965.965,0,0,1,4,20.405a.975.975,0,0,1,.017-.986L9.71,9.852a1,1,0,0,1,1.7,0l5.71,9.55A1.05,1.05,0,0,1,17.119,20.405Z",
    transform: "translate(-2.486 -8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqDraft);
export default __webpack_public_path__ + "static/media/reqDraft.7447c705dd52a9829745a4ef13a7692c.svg";
export { ForwardRef as ReactComponent };